import Box from "@@/elements/Box";
import Container from "@@/elements/Container";
import SvgArrowRight from "@@/elements/Icons/icons/ArrowRight";
import Typography from "@@/elements/Typography";
import { LinkData } from "@@/models/linkdata";
import TextButtonIcon from "../Button/TextButtonIcon";
import styles from "./index.module.scss";
type SideHeaderProps = {
    label?: string;
    header: string;
    link?: LinkData;
    children: React.ReactNode;
    backgroundColor?: "beige" | "white";
};

export const SideHeader = ({ label, header, link, children, backgroundColor }: SideHeaderProps) => {
  
  const getBackgroundColor = (color: string) => {
    switch (color) {
    case "beige":
      return "ComplementaryBeigeTint03";
    default:
      return "White";
    }
  };
  return (

    <Container
      pageGutterX={0}
      className={styles.container}
      size="full"
      backgroundColor={getBackgroundColor(backgroundColor || "white")}
    >
      <Box
        className={styles.side_header}
        backgroundColor={getBackgroundColor(backgroundColor || "white")}>
          
        {label && (
          <div className={styles.side_header__br}>
            <Typography
              textcolor="dark"
              variant="pretitle"
              asElement="div">
              {label}
            </Typography>
            <hr />
          </div>
        )}
        <Typography
          textcolor="dark"
          variant="heading2"
          asElement="h2">
          {header}
        </Typography>
        {link && link.href && link.text && (
          <TextButtonIcon
            label={link.text}
            href={link.href}
            {...link}
            direction="right">  <SvgArrowRight /></TextButtonIcon>
        )}
      </Box>
      <Box className={styles.scroller_container}>
        {children}
      </Box>
    </Container>
  );

};